'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _babelHelperVueJsxMergeProps = require('babel-helper-vue-jsx-merge-props');

var _babelHelperVueJsxMergeProps2 = _interopRequireDefault(_babelHelperVueJsxMergeProps);

var _lib = require('../../lib');

var _PropTypes = require('../../lib/PropTypes');

var _MenuItem = require('./MenuItem');

var _MenuItem2 = _interopRequireDefault(_MenuItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'SuiMenu',
  components: { SuiMenuItem: _MenuItem2.default },
  mixins: [_lib.listenersMixin],
  props: {
    activeIndex: Number,
    color: _PropTypes.Enum.Color(),
    compact: Boolean,
    fixed: Boolean,
    icon: Boolean,
    inverted: Boolean,
    items: Array,
    right: Boolean,
    secondary: Boolean,
    pointing: Boolean,
    tabular: Boolean,
    text: Boolean,
    vertical: Boolean
  },
  render: function render() {
    var _this = this;

    var h = arguments[0];

    var ElementType = (0, _lib.getElementType)(this);
    return h(
      ElementType,
      (0, _babelHelperVueJsxMergeProps2.default)([(0, _lib.getChildProps)(this), this.generateListeners(), {
        'class': (0, _lib.classes)('ui', this.vertical && 'vertical', this.compact && 'compact', this.fixed && 'fixed', this.text && 'text', this.icon && 'icon', this.inverted && 'inverted', this.right && 'right', this.secondary && 'secondary', this.pointing && 'pointing', this.tabular && 'tabular', this.color, 'menu')
      }]),
      [this.$slots.default || this.items && this.items.map(function (item, index) {
        return h(
          _MenuItem2.default,
          (0, _babelHelperVueJsxMergeProps2.default)([{ props: item }, {
            attrs: { active: item.active || _this.activeIndex === index }
          }]),
          []
        );
      })]
    );
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/semantic-ui-vue/dist/commonjs/collections/Menu/Menu.js
// module id = 7zXn
// module chunks = 0